// extracted by mini-css-extract-plugin
export default {"main":"styles_main__iMQl9","variant":"styles_variant__xhI9U","price":"styles_price__1rBMA"};